const shaka = require('external/shaka-player.ui.debug');

const CloseButton = class extends shaka.ui.Element {
  constructor(parent: typeof CloseButton, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = 'Close';
    this.button_.classList.add('shaka-close-button');

    this.parent.appendChild(this.button_);

    setTimeout(() => {
      controls.dispatchEvent(new shaka.util.FakeEvent('closeButtonInitialized', { component: this }));
    });
  }

  setOnClick = (onClick: () => void): void => {
    this.eventManager.listen(this.button_, 'click', () => {
      onClick();
    });
  };
};

// Factory that will create a button at run time.
CloseButton.Factory = class {
  create(rootElement, controls) {
    return new CloseButton(rootElement, controls);
  }
};

export default CloseButton;
